import { render, staticRenderFns } from "./ImpressaoAtendimentos.vue?vue&type=template&id=aa44ebec"
import script from "./ImpressaoAtendimentos.vue?vue&type=script&lang=js"
export * from "./ImpressaoAtendimentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports